<div class="flex flex-col items-center justify-center">
  <div class="mb-4">
    <i-lucide
      class="text-white animate-spin"
      [name]="LoaderCircle"
      size="48"
    ></i-lucide>
  </div>
  <h2 class="text-xl font-semibold text-white text-center mb-2">
    {{ step() }}...
  </h2>
</div>
